// KioskWalletAdapter — STANDALONE/CABINET implementation of WalletPort.
// STUB: not wired to real hardware yet. Credit in/out delegate to a
// MachineServiceClient supplied by the Machine Service host at launch.
// getConfig/placeSpin still settle against the backend when the cabinet is
// online; a fully-offline settlement path is added later (offline-tolerant).
// See ../../machine-service/README.md.

import { WalletPort } from './walletPort';

export class KioskWalletAdapter extends WalletPort {
  constructor({ machineService, backendWallet } = {}) {
    super();
    this._machine = machineService || null;
    // Optional: reuse the web wallet for backend settlement while online.
    this._backend = backendWallet || null;
  }

  get mode() { return 'kiosk'; }

  async getConfig() {
    if (this._backend) return this._backend.getConfig();
    throw new Error('[kiosk] wallet config not wired — provide a backendWallet or offline settlement service. See platform/machine-service/README.md');
  }

  async placeSpin(req) {
    if (this._backend) return this._backend.placeSpin(req);
    throw new Error('[kiosk] spin settlement not wired — provide a backendWallet or offline settlement service');
  }

  async getBalance() {
    if (this._backend) return this._backend.getBalance();
    throw new Error('[kiosk] balance not wired');
  }

  async creditIn(amountDollars) {
    if (!this._machine || typeof this._machine.creditIn !== 'function') {
      throw new Error('[kiosk] machine service not connected — cannot credit in');
    }
    return this._machine.creditIn(amountDollars);
  }

  async creditOut(amountDollars) {
    if (!this._machine || typeof this._machine.creditOut !== 'function') {
      throw new Error('[kiosk] machine service not connected — cannot credit out');
    }
    return this._machine.creditOut(amountDollars);
  }
}
